export function getBuildGenerationGateValue(appVersion: string, appRevision?: string) {
  const trimmedRevision = appRevision?.trim();
  return trimmedRevision || appVersion;
}

export function isBuildGenerationMismatch(currentGeneration: string, incomingGeneration: string) {
  return currentGeneration !== incomingGeneration;
}
